(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/components/instructions-info.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/components/instructions-info.js');
"use strict";

const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  NeedHelp
} = svs.tur;
const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
setGlobal('svs.ticketsOrderHome.components.InstructionsInfo', _ref => {
  let {
    showStepByStep = true
  } = _ref;
  return React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 8,
    sm: 12
  }, showStepByStep && React.createElement(WidgetArea, {
    areaName: "stepByStepWidget"
  }), React.createElement(NeedHelp, null)));
});

 })(window);